import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'available-slot',
  templateUrl: './available-slot.component.html',
})
export class AvailableSlotComponent implements OnInit {
  ngOnInit(): void {}
}
